/**
 * useDeleteSimulatorSession — deletes a `simulator_sessions` row scoped
 * to the current user. Cascades to `simulator_messages` + `simulator_reports`.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSupabaseClient } from "@/lib/supabase";
import { useProfileId } from "@/features/onboarding/hooks/useProfileId";

export function useDeleteSimulatorSession() {
  const qc = useQueryClient();
  const { client } = useSupabaseClient();
  const { profileId } = useProfileId();

  return useMutation<void, Error, string>({
    mutationFn: async (id: string) => {
      if (!profileId) throw new Error("Sessão não pronta. Tente novamente.");
      const { error } = await client
        .from("simulator_sessions")
        .delete()
        .eq("id", id)
        .eq("user_id", profileId);
      if (error) throw new Error(error.message);
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["simulador", "sessions", profileId] });
      void qc.invalidateQueries({ queryKey: ["simulador"] });
    },
  });
}
